import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Service, { inject } from '@ember/service';

var _class, _descriptor, _descriptor2, _descriptor3;
let BeebeeBaseService = (_class = class BeebeeBaseService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _initializerDefineProperty(this, "store", _descriptor3, this);
  }
  get userRole() {
    return this.session.me?.role || {};
  }
  get organizationContactStates() {
    return this.session.contactStates;
  }
  get organizationProductStates() {
    return this.session.productStates;
  }
  findContactState(statusId, stateType = 'contact_states') {
    return this.session._snapshotFindById(stateType, statusId);
  }
  findProductState(statusId, stateType = 'product_states') {
    return this.session._snapshotFindById(stateType, statusId);
  }
  findStateByName(statusName, stateType = 'contact_states') {
    return this.session._snapshotArray(stateType).find(s => s.status_name === statusName);
  }
  get contactStateCliente() {
    return this.findStateByName('Clienti');
  }
  get contactStateFornitore() {
    return this.findStateByName('Fornitori');
  }

  // Metodi di permessi
  isEditable(item, wrapIsEditable) {
    if (wrapIsEditable !== undefined) {
      return wrapIsEditable;
    }
    const modelName = item?.constructor?.modelName;
    const role = this.userRole;
    // role is a plain {} when there is no me/role (no Ember `.get`); guard it.
    if (typeof role?.get !== 'function') {
      return false;
    }
    return role.get(`${modelName}_edit`) || false;
  }
  isContactsEditable(item) {
    return this._checkRole(item, 'contacts');
  }
  isProjectsEditable(item) {
    return this._checkRole(item, 'projects');
  }
  isProductsEditable(item) {
    return this._checkRole(item, 'products');
  }
  isEventsEditable(item) {
    return this._checkRole(item, 'events');
  }
  isPaymentsEditable(item) {
    return this._checkRole(item, 'payments');
  }
  isWorkhoursEditable(item) {
    return this._checkRole(item, 'workhours');
  }
  isFileEditable(item) {
    return this._checkRole(item, 'file');
  }
  isExpensesEditable(item) {
    return this._checkRole(item, 'expenses');
  }
  isInvoicesEditable(item) {
    return this._checkRole(item, 'invoices');
  }
  _checkRole(item, roleName) {
    const modelName = item?.constructor?.modelName;
    const role = this.userRole;
    if (!modelName || !role) {
      return false;
    }
    if (modelName === 'invoice' && item?.estimate) {
      return role.estimate_edit;
    }

    // `userRole` falls back to a plain {} when there is no me/role; that object
    // has no Ember `.get`, so guard before calling it to avoid a TypeError.
    if (typeof role.get !== 'function') {
      return false;
    }
    return role.get(`${modelName}_edit`);
  }

  // Azioni comuni
  reloadItem(item) {
    return item?.reload();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "store", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { BeebeeBaseService as default };
//# sourceMappingURL=beebee-base.js.map
